import React, { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Div } from "../../billing/CardTransactions/styles";
import EditDocument from "../../popups/EditDocument";
import { Button, Image } from "react-bootstrap";
import moment from "moment";
import JoditEditor from "jodit-react";
import { ServDocURL } from "../../../axios/url.js";
import { fileTypes, generateFileURL } from "../../../axios/url.js";
import {
  EditIcon,
  FormHeaderInput,
  FormHeaderInputCloseBtn,
  FormHeaderInputCloseBtnIcon,
  FormHeaderInputSaveBtn,
} from "../../patient/styles";
import { globalColor } from "../../utils/RepeatFunctions/Schedule";
import { Select } from "antd";
import CustomSuffixIcon from "../../popups/CustomSuffixIcon";
import { Modal, Form } from "react-bootstrap";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../../popups/GetStartedPopup.js";
import { AiOutlineSearch, AiOutlineMore } from "react-icons/ai";
import {
  Div1,
  Dropdown,
  DropDown,
  DropDownDiv,
  DropdownItem,
  Input1,
  PatientName,
  TitleLabel,
  TxtSpan,
  DropdownList,
  DropdownContent,
} from "./Styles";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import CloseDoc from "../../../assets/images/CloseDoc.png";
import { GetUserSearchData } from "../../../StateManagement/Reducers/ScheduleState";
import { BsCheckCircle } from "react-icons/bs";
import { useHistory, useLocation } from "react-router-dom";
import { IoCloseSharp } from "react-icons/io5";
import "./TemplateLibraryUI.css";

const TemplateWorkAreas = ({
  closeTemplate,
  savetemplate,
  refreshPatientDetails = () => {},
  EditDocName,
  content,
  app_id,
  fromTemplate,
  CategoryValue,
  speciality,
  appt_endTime,
  patientdetails,
  eid,
  uid,
  providername,
  setShowTemplate,
  isGroupNote,
  portalid,
  deleteTemplate,
}) => {
  //-----------------------------State and Variable Start----------------------------------------------- //
  const dispatch = useDispatch();
  const { Option } = Select;

  const [name, setName] = useState("");
  const [provid, setProvid] = useState("");

  const [selectedProviderId, setSelectedProviderId] = useState(null);
  const [successmsg, setsuccessmsg] = useState(false);
  const [ModalAlerShow1, setModalAlerShow1] = useState(false);

  const [ExtraContent, setExtraContent] = useState("");
  const [ChangedContent, setChangedContent] = useState(content);
  const [templateTitle, setTemplateTitle] = useState(
    EditDocName !== "" || EditDocName !== undefined ? EditDocName : "",
  );
  const [inputValues, setInputValues] = useState({});
  const [DocNameErr, setDocNameErr] = useState(false);
  const [SpecialityErr, setSpecialityErr] = useState(false);

  const [FormDataErr, setFormDataErr] = useState(false);
  const [disBtn, setDisBtn] = useState(false);
  const [Category, setCategory] = useState(
    CategoryValue !== "" && CategoryValue !== undefined
      ? CategoryValue
      : fromTemplate == "Dashboard"
        ? "Intake"
        : "Encounter",
  );
  const [specialty, setSpecial] = useState(
    speciality && speciality !== "" ? speciality : "",
  );
  const [App_id, setApp_id] = useState(0);
  const [openNewTemplate, setOpenNewTemplate] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [searchVal, setSearchVal] = useState("");
  const [DataForUseTemplate, setDataForUseTemplate] = useState("");
  const [TemplateAppId, setTemplateAppId] = useState(0);

  const [searchedData, setSearchedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templateEdit, setTemplateEdit] = useState(false);
  const [autoSaveStatus, setAutoSaveStatus] = useState(""); // "", "Saving...", "Saved", "Error"
  const autoSaveTimerRef = useRef(null);
  const isInitialMount = useRef(true);
  const hasUserEditedRef = useRef(false);
  const [Mode, setMode] = useState("Editor");
  const [templateName, setTemplateName] = useState(
    EditDocName !== "" || EditDocName !== undefined ? EditDocName : "",
  );
  const [openCard, setopenCard] = useState(false);
  const [cosign, setcosign] = useState(false);
  const [isCreate, setIsCreate] = useState();
  const [tosign, settosign] = useState("");
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [disable, setdisable] = useState(true);
  const [primarypro, setprimarypro] = useState("");
  const [saveshow, setsaveshow] = useState(false);
  const [templateshowup6, settemplateshowup6] = useState(false);
  const [viewdocumentdata1, setViewdocumentdata1] = useState("");
  const isDisabled = eid !== "";
  const fref = useRef();
  const isGroup = isGroupNote ? isGroupNote : 0;
  const user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const location = useLocation();
  const history = useHistory();
  const specialtyList = [
    "Plastic Surgery",
    "Dermatology",
    "Sleep Medicine",
    "Allergy & Immunology",
    "Concierge Medicine",
    "Oncology",
    "Palliative Care",
    "Endocrinology",
    "Sports Medicine",
    "Hospice",
    "Podiatry",
    "Pediatrics",
    "Pathology",
    "Obstetrics and Gynecology",
    "Hand Surgery",
    "Hematology",
    "Emergency Medicine",
    "Surgery",
    "Cardiology",
    "Vascular Surgery",
    "Pulmonology",
    "Austism",
    "Radiology",
    "ECG Management",
    "Physical Medicine & Rehabilitation",
    "Opthalmology",
    "Geriatric Medicine",
    "Neurology",
    "Infectious Disease",
    "Nephrology",
    "Ambulatory Care & Surgery",
    "Otolaryngology (ENT)",
    "Rheumatology",
    "Dental Health",
    "Chiropractic",
    "Psychiatry",
    "Urology",
    "Wound Care",
    "Orthopedic Surgery",
    "Behaviour Health",
    "Gastroenterology",
    "Anesthesiology",
    "Family Medicine",
    "Behavioral health therapy",
    "Acupuncture",
    "Lactation consulting",
    "Massage therapy",
    "Counseling",
    "Marriage and family therapy",
    "Psychology",
    "Social work",
    "Dietetics or nutrition counseling",
    "Chiropractic",
    "Applied behavior analysis",
    "Occupational therapy",
    "Physical therapy",
    "Speech-language pathology",
    "Substance use counseling",
    "Other",
  ];
  const UserSearchDatas = useSelector((state) => state.Schedule.UserSearchData);
  const [imagename, setImagename] = useState("");

  const [ViewEditDocumentDataBefore, setViewEditDocumentDataBefore] =
    useState("");

  const ViewEditDocumentDataval = addBorderToTDs(ViewEditDocumentDataBefore);
  const ViewEditDocumentData = disabledremove(ViewEditDocumentDataval);
  const formElementRegex = /<(input|select|checkbox|radio|img|table)/i;
  const checkEditOrNot = formElementRegex.test(ViewEditDocumentData);

  const [duplicateStringBefore, setDuplicateStringBefore] = useState("");
  const duplicateStringDataval = addBorderToTDs(duplicateStringBefore);
  const duplicateString = disabledremove(duplicateStringDataval);

  //-----------------------------State and Variable End----------------------------------------------- //

  //-----------------------------Functions Start------------------------------------------------------ //

  const extractValuesBetweenTildes = (val, placeholder) => {
    const regex = /~(.*?)~/g;
    const matches = [];
    let match;

    while ((match = regex.exec(val)) !== null) {
      matches[match.index - placeholder.length] = match[1];
    }
    return matches;
  };

  let rowCounterMap = {};
  const handlePlaceholderReplace = (placeholder, index, inputValue) => {
    const id = placeholder.replace(/{|}/g, ""); // Remove curly braces
    const value = inputValues[id] || "";
    var valueofArray = extractValuesBetweenTildes(
      ViewEditDocumentData,
      placeholder,
    );
    if (placeholder === "inputbox") {
      return `<input type="text" class="inputbox" data-input-id="${index}" value="${
        valueofArray[index] !== undefined ? valueofArray[index] : inputValue
      }"></input>`;
    } else if (placeholder === "datepicker") {
      return `<input type="date" data-input-id="${index}" class="datepicker" value="${
        valueofArray[index] !== undefined ? valueofArray[index] : value
      }"></input>`;
    } else if (placeholder === "signature") {
      return `<p style="font-style: italic;" class="signature" data-input-id="11" data-input-id="${index}" value="${
        valueofArray[index] !== undefined ? valueofArray[index] : imagename
      }"></input>`;
    } else if (placeholder === "radiobox") {
      return `<input type="radio" class="radiobox" data-input-id="${index}" value="Yes" name="${index}ynRadioGroup"
       ${
         valueofArray[index] !== undefined && valueofArray[index] === "Yes"
           ? "checked"
           : ""
       }
        />
        <input type="radio" class="radiobox" data-input-id="${index}" value="No" name="${index}ynRadioGroup" ${
          valueofArray[index] !== undefined && valueofArray[index] === "No"
            ? "checked"
            : ""
        }/>`;
    } else if (placeholder === "radioboxGroup") {
      const lastTrIndex = ViewEditDocumentData.lastIndexOf("<tr", index);

      if (!rowCounterMap.hasOwnProperty(lastTrIndex)) {
        rowCounterMap[lastTrIndex] = 0;
      }

      rowCounterMap[lastTrIndex]++;

      const counter = rowCounterMap[lastTrIndex];

      const name = "radioGroup" + lastTrIndex;

      return `<input type="radio" class="radioboxGroup" data-input-id="${index}" value="${counter}" name="${name}" ${
        valueofArray[index] !== undefined &&
        valueofArray[index] === counter.toString()
          ? "checked"
          : ""
      }></input>`;
    } else {
      return placeholder;
    }
  };

  const filedownload = async (id) => {
    var article = {
      file: patientdetails.note_file_url,
      id: patientdetails.note_add_edit,
      testurl: ServDocURL,
      Appointment: fromTemplate,
    };
    let encrypted = Encrypt_Value(article, "vozo");
    axiosInstance
      .put("vozo/PreviewDownloadNotes", encrypted)
      .then((response) => {
        const fileUrl = response.data.file;

        const rawFilename =
          response.data.filename ||
          fileUrl.substring(fileUrl.lastIndexOf("/") + 1) ||
          `Note_${id}.pdf`;

        const decodedFilename = decodeURIComponent(rawFilename);

        var tag = document.createElement("a");
        tag.href = fileUrl;
        tag.download = decodedFilename;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);

        var articledelete = { id: id };
        let encrypteddelete = Encrypt_Value(articledelete, "vozo");
        axiosInstance
          .put("vozo/DeleteTempDocumentDataNotes", encrypteddelete)
          .then((response) => {});
      });
  };
  const handlesetSpecial = (data) => {
    const selectedValue = data?.value || "";
    setSpecial(selectedValue);
    if (selectedValue !== "") {
      setSpecialityErr(false);
    } else {
      setSpecialityErr(true);
    }
  };

  const OpenCard = () => {
    setopenCard(!openCard);
  };

  const setContentToParent = (value) => {
    hasUserEditedRef.current = true;
    setChangedContent(value);
  };

  const DeleteNote = () => {
    if (deleteTemplate) {
      deleteTemplate(app_id);
      closeTemplate();
      return;
    }

    axiosInstance
      .post(
        "/vozo/DeleteAppointment/Notes?app_id=" +
          App_id +
          "&is_grp=" +
          isGroup +
          "&portalid=" +
          portalid,
      )
      .then((response) => {
        let temp_role_count_ser = Decrypt_Value(response.data, "vozo");
        refreshPatientDetails();
      })
      .catch((err) => console.error(err));
    closeTemplate();
  };

  const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const formEdit = () => {
    setTemplateEdit(!templateEdit);
  };
  const saveFormHeader = () => {
    hasUserEditedRef.current = true;
    setTemplateName(templateTitle);
    formEdit();
  };

  const ModifiedStringFin = ViewEditDocumentData.replace(
    /{[^}]+}/g,
    (match, index) => {
      const inputValue = inputValues[match];
      return handlePlaceholderReplace(match, index, inputValue);
    },
  );

  function addBorderToTDs(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const tds = doc.querySelectorAll("td");

    tds.forEach((td) => {
      td.style.border = "1px solid 	#000000";
      td.style.padding = "8px";
    });

    return doc.documentElement.outerHTML;
  }
  function disabledremove(value) {
    const parser = new DOMParser();

    const doc = parser.parseFromString(value, "text/html");
    const inputElements = doc.querySelectorAll("input, select,img");
    inputElements.forEach((input) => {
      input.removeAttribute("disabled");
    });

    return doc.documentElement.outerHTML;
  }

  const handleUpdate = () => {
    const ModifiedStringFinal = ModifiedStringFin; // Assign modified content
    setViewdocumentdata1(ModifiedStringFinal); // Set the updated string in the state
  };

  const printpage = () => {
    if (Mode === "Viewer") {
      // Process ChangedContent to wrap table cell text with <p> tags

      let processedContent = setStringreplace();

      if (processedContent) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(processedContent, "text/html");

        // Process all table cells
        const tableCells = doc.querySelectorAll("td, th");

        tableCells.forEach((cell) => {
          const currentContent = cell.innerHTML.trim();

          // Check if content is just text (no HTML tags except <br>)
          const hasOnlyTextAndBreaks = /^[^<>]*(<br\s*\/?>[^<>]*)*$/.test(
            currentContent,
          );

          // Only wrap if it's plain text or text with line breaks
          if (
            currentContent &&
            hasOnlyTextAndBreaks &&
            currentContent !== "<br>" &&
            currentContent !== "&nbsp;"
          ) {
            // Replace <br> tags with closing and opening <p> tags to create paragraphs
            let wrappedContent = currentContent;

            if (currentContent.includes("<br>")) {
              // Split by <br> and wrap each part in <p> tags
              const parts = currentContent.split(/<br\s*\/?>/);
              wrappedContent = parts
                .map((part) => {
                  const trimmedPart = part.trim();
                  return trimmedPart ? `<p>${trimmedPart}</p>` : "";
                })
                .join("");
            } else {
              // Simple text content, just wrap in <p>
              wrappedContent = `<p>${currentContent}</p>`;
            }

            cell.innerHTML = wrappedContent;
          }
        });

        // Convert back to string and update ChangedContent
        processedContent = doc.body.innerHTML;
      }

      return processedContent;
    } else {
      if (fref.current?.setFromOutside) {
        var data = fref.current.setFromOutside();

        // Process data to wrap table cell text with <p> tags
        if (data) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, "text/html");

          // Process all table cells
          const tableCells = doc.querySelectorAll("td, th");

          tableCells.forEach((cell) => {
            const currentContent = cell.innerHTML.trim();

            // Check if content is just text (no HTML tags except <br>)
            const hasOnlyTextAndBreaks = /^[^<>]*(<br\s*\/?>[^<>]*)*$/.test(
              currentContent,
            );

            // Only wrap if it's plain text or text with line breaks
            if (
              currentContent &&
              hasOnlyTextAndBreaks &&
              currentContent !== "<br>" &&
              currentContent !== "&nbsp;"
            ) {
              // Replace <br> tags with closing and opening <p> tags to create paragraphs
              let wrappedContent = currentContent;

              if (currentContent.includes("<br>")) {
                // Split by <br> and wrap each part in <p> tags
                const parts = currentContent.split(/<br\s*\/?>/);
                wrappedContent = parts
                  .map((part) => {
                    const trimmedPart = part.trim();
                    return trimmedPart ? `<p>${trimmedPart}</p>` : "";
                  })
                  .join("");
              } else {
                // Simple text content, just wrap in <p>
                wrappedContent = `<p>${currentContent}</p>`;
              }

              cell.innerHTML = wrappedContent;
            }
          });

          // Convert back to string
          data = doc.body.innerHTML;
        }

        return data;
      }
    }
  };

  const makeInputIdsUnique = (htmlString) => {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = htmlString;

    // Keep track of radio groups we’ve seen
    const radioGroupsHandled = new Set();
    let uniqueIndex = 1;

    const allElements = wrapper.querySelectorAll("[data-input-id]");

    allElements.forEach((el) => {
      const type = el.getAttribute("type");
      const name = el.getAttribute("name");

      const isRadio = type === "radio";

      if (isRadio && name) {
        if (radioGroupsHandled.has(name)) {
          // Already handled this radio group, skip assigning unique name/id
          return;
        }

        // Handle all radios with the same name together
        const sameGroupRadios = wrapper.querySelectorAll(
          `input[type="radio"][name="${CSS.escape(name)}"]`,
        );
        sameGroupRadios.forEach((radio) => {
          radio.setAttribute("data-input-id", uniqueIndex);
          radio.setAttribute("name", name); // keep original group name
        });

        radioGroupsHandled.add(name);
        uniqueIndex++;
      } else {
        // Non-radio inputs or standalone radios
        el.setAttribute("data-input-id", uniqueIndex);
        if (el.hasAttribute("name")) {
          el.setAttribute("name", `${uniqueIndex}`);
        }
        uniqueIndex++;
      }
    });

    return wrapper.innerHTML;
  };

  const savedocument = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    var err = 0;
    var temp;

    const isAutoSave = e === null;
    const targetName = e?.target?.name || "";

    if (isAutoSave || targetName !== "UnLockSupervisor") {
      temp = printpage();
    }
    if (temp === undefined) {
      temp = "";
    }
    temp = makeInputIdsUnique(temp);

    if (templateName === "" || (templateName && templateName.length < 3)) {
      if (!isAutoSave) {
        setDocNameErr(true);
        setTemplateEdit(true);
      }
      err = 2;
    } else {
      setTemplateEdit(false);
    }

    if (
      specialty === "Select Specialty" ||
      specialty === "" ||
      specialty === undefined
    ) {
      if (!isAutoSave) setSpecialityErr(true);
      err = 2;
    } else {
      setSpecialityErr(false);
    }
    if (
      !isAutoSave &&
      targetName !== "UnLock" &&
      targetName !== "UnLockSupervisor" &&
      patientdetails.sign_lock !== 1
    ) {
      const cleanedTemp = temp
        .replace(/\s/g, "")
        .replace(/&nbsp;/gi, "")
        .toLowerCase();

      if (
        cleanedTemp === "" ||
        cleanedTemp === "<p></p>" ||
        cleanedTemp === "<p><br></p>"
      ) {
        setFormDataErr(true);
        err = 2;
      } else {
        setFormDataErr(false);
      }
    }
    if (err > 0 && !isAutoSave) {
      setDisBtn(false);
      return false;
    }

    // During auto-save, we only want to proceed if validation passed
    if (err > 0 && isAutoSave) return false;

    setDisBtn(true);
    let ForType;
    let SupType;
    if (targetName) {
      if (targetName === "SignLock") {
        ForType = "SignLock";
      } else if (targetName === "UnLock") {
        ForType = "UnLock";
      } else if (targetName === "SignLockSupervisor") {
        SupType = "SignLock";
      } else if (targetName === "UnLockSupervisor") {
        SupType = "UnLock";
      }
    } else {
      ForType = null;
      SupType = null;
    }

    const result = await savetemplate(
      temp,
      templateName.replace(/[.,\s]/g, "_"),
      Category,
      specialty,
      ForType,
      isAutoSave,
      SupType,
      provid,
      isSupervisor,
    );
    if (e !== null) {
      setTemplateName("");
      setTemplateTitle("");
    }
    setDisBtn(false);
    if (templateshowup6 && !isAutoSave) {
      setShowTemplate(false);
      forexploretemplatemenu7();
    }
    return result;
  };

  const forexploretemplatemenu7 = () => {
    settemplateshowup6(false);
    history.replace({
      pathname: location.pathname,
      search: "?step=5.7",
    });
  };

  const forexploretemplatemenu5 = () => {
    settemplateshowup6(false);
    history.replace({
      pathname: location.pathname,
      search: "?step=5.5",
    });
  };

  const setUseTemplate = (templateNameArg, templateIdArg, fileUrlArg) => {
    const tName = templateNameArg || searchVal;
    const tId = templateIdArg || TemplateAppId;
    const tUrl = fileUrlArg || DataForUseTemplate;

    if (tUrl !== "") {
      var article = { path: tUrl, id: tId };
      let encrypted = Encrypt_Value(article, "vozo");
      axiosInstance
        .put("/vozo/patient/get/Document/one", encrypted)
        .then((response) => {
          let data = Decrypt_Value(response.data, "vozo");
          if (data) {
            let Usecontent = `<!-- ~${tName}~ -->
              <hr>
              <p style="text-align: center;">
                <strong style="font-size: 18px;">${tName}</strong>
             
              </p>
              <br>
              ${data}
              <hr>`;
            setExtraContent(Usecontent.replaceAll('disabled=""', ""));
            setOpenNewTemplate(false);
          }
        });
    }
  };
  const setCategoryValue = (val) => {
    setCategory(val);
  };

  const addDisabled = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const inputElements = doc.querySelectorAll("input, select, img");

    inputElements.forEach((element) => {
      element.setAttribute("disabled", ""); // Set disabled normally
    });

    // Convert back to string and remove `disabled=""` with regex
    let modifiedHTML = doc.documentElement.outerHTML.replace(
      /\sdisabled=""/g,
      " disabled",
    );

    return modifiedHTML;
  };

  const changeMode = (value) => {
    if (value === "Editor") {
      var ChangedC = setStringreplace();

      setChangedContent(addDisabled(ChangedC));
    } else {
      var changedC = printpage();
      var testtemp = makeInputIdsUnique(changedC);

      var newDisbaledContent = disabledremove(testtemp);
      const updatedHtml = newDisbaledContent
        // Add `border: 1px solid black;` to each <td>
        .replace(/<td(.*?)style="(.*?)"/g, (match, before, style) => {
          if (style.includes("border")) return match;
          return `<td${before}style="${style}; border-radius: 6px;border: 1px solid #d8e0f0;"`;
        })
        // Add border style if <td> has no style
        .replace(
          /<td(?![^>]*style=)/g,
          `<td style="border-radius: 6px;border: 1px solid #d8e0f0;"`,
        )
        // Add border-collapse and border to <table>
        .replace(/<table(.*?)style="(.*?)"/g, (match, before, style) => {
          if (style.includes("border-collapse")) return match;
          return `<table${before}style="${style}; border-collapse: collapse;border-radius: 6px; border: 1px solid #d8e0f0;"`;
        })
        .replace(
          /<table(?![^>]*style=)/g,
          `<table style="border-collapse: collapse;border-radius: 6px; border: 1px solid #d8e0f0;"`,
        );

      setChangedContent(updatedHtml);
    }

    setMode(value);
  };

  const setStringreplace = () => {
    const inputValues = {};
    const tableValues = {};

    // Capture input and select values
    const inputElements = document.querySelectorAll("input, select");

    inputElements.forEach((inputElement) => {
      const inputId = inputElement.getAttribute("data-input-id");
      let inputValue = inputElement.value;

      if (inputElement.type === "radio" && inputElement.checked === true) {
        inputValue = inputElement.value;
        inputValues[inputId] = inputValue;
      } else if (inputElement.tagName === "SELECT" && inputElement.multiple) {
        const selectedValues = Array.from(inputElement.selectedOptions).map(
          (option) => option.value,
        );
        inputValues[inputId] = selectedValues;
      } else if (inputElement.tagName === "SELECT") {
        inputValues[inputId] = inputValue;
      }

      if (inputElement.type !== "radio" && inputElement.tagName !== "SELECT") {
        inputValues[inputId] = inputValue;
      }
    });

    // Now capture table data from processed tables
    const processedTables = document.querySelectorAll(
      ".editable-content-table",
    );

    processedTables.forEach((table) => {
      const tableId = table.getAttribute("data-table-id");
      const tableData = [];
      const rows = table.querySelectorAll("tr");

      rows.forEach((row, rowIndex) => {
        const rowData = [];
        const cells = row.querySelectorAll(".editable-content-cell");

        cells.forEach((cell, cellIndex) => {
          let cellContent = cell.innerHTML.trim();
          cellContent = cellContent.replace(/&nbsp;/g, " ").trim();

          // Clean up empty content
          if (cellContent === "<br>" || cellContent === "") {
            cellContent = "";
          }

          rowData.push({
            content: cellContent,
            isHeader: cell.tagName === "TH",
            row: rowIndex,
            cell: cellIndex,
            tableId: tableId,
            cellId: cell.getAttribute("data-cell-index"),
            isEditable: cell.getAttribute("contenteditable") === "true",
          });
        });

        if (rowData.length > 0) {
          tableData.push(rowData);
        }
      });

      if (tableData.length > 0) {
        tableValues[`editable_table_${tableId}`] = {
          data: tableData,
          html: table.outerHTML,
        };
      }
    });

    // Update input and select elements in the original duplicateString
    const modifiedStringEditSave = duplicateString.replace(
      /<input[^>]+data-input-id="(\d+)"[^>]*>/g,
      (match, id) => {
        const inputValue = inputValues[id] || "";
        const isRadiobox = /class="radiobox"/.test(match);
        const isRadioboxGroup = /class="radioboxGroup"/.test(match);
        let isChecked = false;

        if (isRadiobox) {
          const radioMatch = match.match(/value="([^"]*)"/);
          if (radioMatch) {
            const radioValue = radioMatch[1];
            isChecked = inputValue === radioValue;
          }
          return match
            .replace(/checked="checked"/g, "")
            .replace(/>/, isChecked ? ' checked="checked">' : ">");
        }

        if (isRadioboxGroup) {
          const radioMatch = match.match(/data-input-id="([^"]*)"/);
          if (radioMatch !== null) {
            const radioDataInputId = radioMatch[1];
            if (inputValues[radioDataInputId] != null) {
              const radioValueMatch = match.match(/value="([^"]*)"/);
              const radioValue =
                radioValueMatch && radioValueMatch[1] !== ""
                  ? radioValueMatch[1]
                  : inputValues[radioDataInputId];
              isChecked = inputValues[radioDataInputId] === radioValue;
              return match
                .replace(/checked="checked"/g, "")
                .replace(
                  /value="[^"]*"/,
                  isChecked ? `value="${radioValue}"` : "",
                )
                .replace(/>/, isChecked ? ' checked="checked" >' : " >");
            }
          }
        }

        return match.replace(/value="[^"]*"/, `value="${inputValue}"`);
      },
    );

    const updatedStringWithSelect = modifiedStringEditSave.replace(
      /<select[^>]+id=["'](\d+)["'][^>]*>[\s\S]*?<\/select>/g,
      (match, id) => {
        const inputValue = inputValues[id];
        const selectedValues = Array.isArray(inputValue)
          ? inputValue
          : inputValue
            ? [inputValue]
            : [];

        const updatedSelect = match.replace(
          /<option[^>]+value="([^"]+)"[^>]*>/g,
          (optionMatch, optionValue) => {
            const isSelected = selectedValues.includes(optionValue);
            return optionMatch
              .replace(/selected="selected"/g, "")
              .replace(">", isSelected ? ' selected="selected">' : ">");
          },
        );

        return updatedSelect;
      },
    );

    let finalContent = updatedStringWithSelect;

    // APPLY TABLE DATA TO FINAL CONTENT
    if (Object.keys(tableValues).length > 0) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(finalContent, "text/html");

      // Process all tables in the final content
      const contentTables = doc.querySelectorAll("table");

      contentTables.forEach((table, index) => {
        const tableKey = `editable_table_${index}`;

        if (tableValues[tableKey]) {
          const tableData = tableValues[tableKey].data;
          const rows = table.querySelectorAll("tr");

          tableData.forEach((rowData, rowIndex) => {
            if (rows[rowIndex]) {
              const cells = rows[rowIndex].querySelectorAll("td, th");

              rowData.forEach((cellData) => {
                if (cells[cellData.cell]) {
                  // Update editable cells with captured content
                  cells[cellData.cell].innerHTML = cellData.content || "&nbsp;";
                }
              });
            }
          });
        }
      });

      finalContent = doc.body.innerHTML;
    }

    // return;
    const targetContainer = document.querySelector(".target-container");
    if (targetContainer) {
      targetContainer.innerHTML = finalContent;
    }

    return finalContent;
  };
  const handleSign = (isSupervising) => {
    setIsSupervisor(isSupervising);
    setIsCreate(true);
  };

  const updateImageInDocument = (modifiedString, imagename, value) => {
    if (!modifiedString) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(modifiedString, "text/html");

    // Handle signature images
    if (
      imagename &&
      imagename !== "" &&
      imagename !== undefined &&
      imagename !== null
    ) {
      doc.querySelectorAll("img.signature").forEach((img) => {
        const id = img.getAttribute("data-input-id");
        const p = document.createElement("p");
        p.setAttribute("style", "font-family: 'Shadows Into Light', cursive;");
        p.setAttribute("data-input-id", id);
        p.setAttribute("class", "signature");
        p.textContent = imagename;
        img.replaceWith(p);
      });
    }

    // Make only empty table cells editable
    const tables = doc.querySelectorAll("table");
    tables.forEach((table, index) => {
      // Add unique classname for identification
      table.classList.add("editable-content-table");
      table.classList.add(`table-${index}`);

      // Add data attribute for additional identification
      table.setAttribute("data-table-id", index);

      table.setAttribute("contenteditable", "false"); // Make table non-editable
      table.style.border = "1px solid #ccc";
      table.style.borderCollapse = "collapse";
      table.style.margin = "10px 0";
      table.style.width = "100%";

      const cells = table.querySelectorAll("td, th");
      cells.forEach((cell, cellIndex) => {
        // Add unique identifiers to cells as well
        cell.classList.add("editable-content-cell");
        cell.setAttribute("data-table-id", index);
        cell.setAttribute("data-cell-index", cellIndex);

        cell.style.border = "1px solid #ddd";
        cell.style.padding = "8px";
        cell.style.minWidth = "50px";

        // Check if cell has <p> tag

        // Cell doesn't have <p> tag - make it editable
        cell.setAttribute("contenteditable", "true");
        cell.style.backgroundColor = "#fff";
        cell.style.cursor = "text";

        // Only set &nbsp; if cell is truly empty
        if (
          cell.innerHTML.trim() === "" ||
          cell.innerHTML === "<br>" ||
          cell.innerHTML === "&nbsp;"
        ) {
          cell.innerHTML = "&nbsp;";
        }
        // }
      });
    });

    const finalContent = doc.body.innerHTML;
    return finalContent;
  };

  const HanldeCloseSignature = () => {
    setIsCreate(false);
    settosign("");
  };

  const handleprimaryproviderchange = async (pvalue) => {
    var article = {
      primaryprovider: pvalue,
      mainPro: primarypro,
    };

    let encrypted = Encrypt_Value(article, "vozo");
    await axiosInstance
      .put("/vozo/note/primaryproviderchange?user_ID=" + uid, encrypted)
      .then((response) => {
        let temp_role = Decrypt_Value(response.data, "vozo");
        const changeprovider = temp_role.username;
        setName(changeprovider);
        setIsCreate(false);
        axiosInstance
          .get("/vozo/note/signorcosign?user_ID=" + uid)
          .then((response) => {
            let temp_role = Decrypt_Value(response.data, "vozo");

            // Safely check if setting_value exists
            const setting = temp_role[0]?.setting_value;
            if (setting !== undefined) {
              setcosign(setting === "1");
            } else {
              setcosign(false); // or handle fallback
            }

            const mainPro = String(temp_role[1]?.main_pro || "").trim();
            setprimarypro(mainPro);

            const currentUserId = String(user_ID).trim();

            if (owner_id === null || mainPro === currentUserId) {
              setdisable(false);
            } else {
              setdisable(true);
            }
          })
          .catch((err) => {
            console.error("Error fetching signor/cosign data:", err);
          });
        setsuccessmsg("Supervisor Updated Successfully");
        setModalAlerShow1(true);
        setTimeout(() => {
          setModalAlerShow1(false);
          setsaveshow(false);
        }, 40000);
      });
  };
  //-----------------------------Functions End------------------------------------------------------ //

  //-----------------------------UseEffect Start--------------------------------------------------- //
  useEffect(() => {
    axiosInstance
      .get("/vozo/note/signorcosign?user_ID=" + uid)
      .then((response) => {
        let temp_role = Decrypt_Value(response.data, "vozo");

        // Safely check if setting_value exists
        const setting = temp_role[0]?.setting_value;
        if (setting !== undefined) {
          setcosign(setting === "1");
        } else {
          setcosign(false); // or handle fallback
        }

        const mainPro = String(temp_role[1]?.main_pro || "").trim();
        setprimarypro(mainPro);

        const currentUserId = String(user_ID).trim();

        if (owner_id === null || mainPro === currentUserId) {
          setdisable(false);
        } else {
          setdisable(true);
        }
      })
      .catch((err) => {
        console.error("Error fetching signor/cosign data:", err);
      });
    let article =
      "&authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&owner_id=" +
      owner_id +
      "&userID=" +
      user_ID +
      "&pat_share=" +
      storedNames.pat_g;

    dispatch(GetUserSearchData(article));

    if (eid !== "" && eid !== undefined) {
      if (patientdetails.note_add_edit !== 0) {
        axiosInstance
          .get("/vozo/patient/note/details?id=" + patientdetails.note_add_edit)
          .then((response) => {
            let temp_role_pat_det = Decrypt_Value(response.data, "vozo");

            setApp_id(temp_role_pat_det.app_id);
            if (temp_role_pat_det.speciality) {
              setSpecial(temp_role_pat_det.speciality);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        axiosInstance
          .get("/vozo/patient/macros/speciality?id=" + app_id)
          .then((response) => {
            let temp_role_pat_det = Decrypt_Value(response.data, "vozo");
            if (temp_role_pat_det.speciality) {
              setSpecial(temp_role_pat_det.speciality);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
    if (portalid !== undefined && portalid !== null && portalid !== 0) {
      axiosInstance
        .get(
          "/vozo/patient/note/details?id=" +
            patientdetails.note_add_edit +
            "&portaldocid=" +
            portalid,
        )
        .then((response) => {
          let temp_role_pat_det = Decrypt_Value(response.data, "vozo");

          setApp_id(temp_role_pat_det.app_id);
          if (temp_role_pat_det.speciality) {
            setSpecial(temp_role_pat_det.speciality);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  useEffect(() => {
    if (speciality && speciality !== "") {
      setSpecial(speciality);
    } else {
      setSpecial("");
    }
  }, [speciality]);

  useEffect(() => {
    const isOwnerNull =
      owner_id === null || owner_id === "null" || owner_id === "";
    const isPrimaryProNull =
      primarypro === null || primarypro === "null" || primarypro === "";

    if (isOwnerNull && isPrimaryProNull) {
      const matchedUser = UserSearchDatas.find((user) => user.id);
      if (matchedUser) {
        setName(matchedUser.title);
        setProvid(matchedUser.id);
      }
    } else {
      const matchedUser = UserSearchDatas.find(
        (user) => user.id === primarypro,
      );
      if (matchedUser) {
        setName(matchedUser.title);
        setProvid(matchedUser.id);
      }
    }
  }, [UserSearchDatas, primarypro]);

  const clearExtraContent = () => {
    setSearchVal("");
    setTemplateAppId(0);
    setDataForUseTemplate("");
    setExtraContent("");
  };

  useEffect(() => {
    const handleBackspace = (e) => {
      if (e.key === "Backspace") {
        // If the target is an input, textarea, or contenteditable element, stop propagation
        const target = e.target;
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
          e.stopPropagation();
        }
      }
    };

    document.addEventListener("keydown", handleBackspace, true);

    return () => {
      document.removeEventListener("keydown", handleBackspace, true);
    };
  }, []);

  useEffect(() => {
    if (!imagename) {
      handleUpdate();
    }
  }, [ViewEditDocumentData]);

  useEffect(() => {
    const handleInputChange = (event) => {
      const input = event.target;
      const id = input.getAttribute("data-input-id");
      const value = input.value;

      if (input.tagName === "SELECT" && input.type !== "radio") {
        if (input.multiple) {
          const selectedValues = Array.from(input.selectedOptions).map(
            (option) => option.value,
          );

          setInputValues((prevValues) => ({
            ...prevValues,
            [id]: selectedValues,
          }));
        } else {
          const selectedValue = input.value;
          setInputValues((prevValues) => ({
            ...prevValues,
            [id]: selectedValue,
          }));
        }
      } else if (
        input.type === "radio" &&
        input.checked &&
        input.tagName !== "SELECT"
      ) {
        const radioGroupName = input.name;
        const radioButtons = document.querySelectorAll(
          `input[name="${radioGroupName}"]`,
        );
        radioButtons.forEach((radio) => {
          if (radio !== input) {
            radio.removeAttribute("checked");
          }

          input.setAttribute("checked", "checked");
          if (radio.classList.contains("radioboxGroup")) {
            radio.setAttribute("value", "Yes");
          }
        });
        setInputValues((prevValues) => ({
          ...prevValues,
          [id]: value,
        }));
      }
    };

    // const handleImageClick = () => {
    //   setSignature(true);

    //   setImage("fromimage");
    // };

    const attachEventListeners = () => {
      const selectInputs = document.querySelectorAll("select[data-input-id]");

      selectInputs.forEach((select) => {
        select.addEventListener("change", handleInputChange);
      });

      const radioBoxInputs = document.querySelectorAll(
        'input[type="radio"].radiobox[data-input-id]',
      );
      const radioBoxGroupInputs = document.querySelectorAll(
        'input[type="radio"].radioboxGroup[data-input-id]',
      );

      radioBoxInputs.forEach((input) => {
        input.addEventListener("change", handleInputChange);
      });

      radioBoxGroupInputs.forEach((input) => {
        input.addEventListener("change", handleInputChange);
      });

      const signatureImage = document.querySelector(
        "img.signature[data-input-id]",
      );
      // if (signatureImage) {
      //   signatureImage.addEventListener("click", handleImageClick);
      // }
      const signatureImages = document.querySelectorAll("img.signature");
      // signatureImages.forEach((signatureImage) => {
      //   signatureImage.addEventListener("click", handleImageClick);
      // });
      return () => {
        selectInputs.forEach((select) => {
          select.removeEventListener("change", handleInputChange);
        });
        radioBoxInputs.forEach((input) => {
          input.removeEventListener("change", handleInputChange);
        });
        radioBoxGroupInputs.forEach((input) => {
          input.removeEventListener("change", handleInputChange);
        });
        // if (signatureImage) {
        //   signatureImage.removeEventListener("click", handleImageClick);
        // }
        // return () => {
        //   signatureImages.forEach((signatureImage) => {
        //     signatureImage.removeEventListener("click", handleImageClick);
        //   });
        // };
      };
    };

    const cleanup = attachEventListeners();

    const observer = new MutationObserver(() => {
      cleanup();
      attachEventListeners();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      cleanup();
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    setViewEditDocumentDataBefore(ChangedContent);
    setDuplicateStringBefore(ChangedContent);
  }, [ChangedContent]);

  useEffect(() => {
    if (eid !== "") {
      if (patientdetails.note_add_edit !== 0) {
        setChangedContent(content);
      } else {
        axiosInstance
          .get("/vozo/getNotes/DefaultData")
          .then((response) => {
            let temp_role_pat_det = Decrypt_Value(response.data, "vozo");

            if (
              Array.isArray(temp_role_pat_det) &&
              temp_role_pat_det.length === 0
            ) {
              setChangedContent("");
            } else {
              setChangedContent(temp_role_pat_det);
            }
          })
          .catch((err) => {
            console.error(err);
          });
        setChangedContent(content);
      }
    } else {
      setChangedContent(content);
    }
  }, [content]);

  useEffect(() => {
    let isCancelled = false;

    const handlechange = async () => {
      await timeout(500);

      if (!isCancelled) {
        setLoading(true);

        // Fetch templates. We fetch all initially to allow frontend filtering by categories,
        // matching the behavior of the main library page more reliably.
        let apiUrl = "/vozo/patient/templatelibrary/data?notetype=1";

        if (searchVal && searchVal.trim() !== "") {
          const art1 =
            "formname=" +
            (searchVal || "").toLowerCase() +
            "&doctype=All&speciality=All";
          const encrypt = Encrypt_Value(art1, "vozo");
          apiUrl =
            "/vozo/patient/templatelibrary/data?search=" +
            encrypt +
            "&notetype=1";
        }

        await axiosInstance
          .get(apiUrl)
          .then((res) => {
            let decrypt_res = Decrypt_Value(res.data, "vozo");
            setSearchedData(Array.isArray(decrypt_res) ? decrypt_res : []);
          })
          .catch((err) => {
            setSearchedData([]);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    };
    handlechange();
    return () => {
      isCancelled = true;
    };
  }, [searchVal]);

  useEffect(() => {
    if (EditDocName === undefined) {
      setTemplateName("");
      setTemplateTitle("");
    } else {
      setTemplateName(EditDocName);
      setTemplateTitle(EditDocName);
    }
  }, [EditDocName]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const step = query.get("step");

    if (step === "5.6") {
      settemplateshowup6(true);
      query.delete("step");
      history.replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
  }, [location?.search]);

  useEffect(() => {
    // If it's a new template being created, we might want to skip auto-save
    // until at least a name is provided.
    const canAutoSave =
      templateName &&
      templateName.length >= 3 &&
      specialty &&
      specialty !== "" &&
      specialty !== "Select Specialty" &&
      Mode === "Editor";

    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (!canAutoSave) return;
    if (!hasUserEditedRef.current) return;

    // Clear previous timer
    if (autoSaveTimerRef.current) {
      clearTimeout(autoSaveTimerRef.current);
    }

    // Set new timer for 3 seconds
    autoSaveTimerRef.current = setTimeout(async () => {
      setAutoSaveStatus("Saving...");
      try {
        const success = await savedocument(null); // Pass null for auto-save
        if (success !== false) {
          hasUserEditedRef.current = false;
          setAutoSaveStatus("Saved");
          setTimeout(() => setAutoSaveStatus(""), 2000);
        } else {
          setAutoSaveStatus("Error");
        }
      } catch (err) {
        setAutoSaveStatus("Error");
      }
    }, 3000); // 3 seconds of no interaction as requested

    return () => {
      if (autoSaveTimerRef.current) clearTimeout(autoSaveTimerRef.current);
    };
  }, [ChangedContent, specialty, Category, templateName]);

  //-----------------------------UseEffect End---------------------------------------------------- //

  return (
    <>
      <Div
        height="48px"
        backgroundColor={globalColor}
        color="#FFFFFF"
        dis="flex"
        justifyContent="center"
        padding="0px 10px"
      >
        {!templateEdit ? (
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <span className="consent-form-titlename">
                  {templateName === "" ? "New Document Template" : templateName}
                </span>
                {patientdetails.sign_lock !== 1 && (
                  <EditIcon onClick={formEdit} />
                )}
              </div>
              <img
                alt=""
                className="template_img_dropdown_close"
                src={CloseDoc}
                height="24px"
                width="24px"
                onClick={closeTemplate}
              />
            </div>
          </>
        ) : (
          <>
            {/* NEW: onBlur auto-saves the title instead of requiring a Save button click */}
            <FormHeaderInput
              border={DocNameErr}
              onChange={(e) => {
                const value = e.target.value.replace(/[\/\\*<>?#%]/g, "");
                hasUserEditedRef.current = true;
                setTemplateTitle(value);
                setDocNameErr(false);
              }}
              onBlur={() => {
                if (templateTitle !== "") {
                  saveFormHeader();
                }
              }}
              value={templateTitle}
              style={{
                width: "90%",
                borderRadius: "4px",
                color: "black",
                outline: "none",
                border: "none",
              }}
            />
            {DocNameErr ? (
              <p className="errormessage Rev_count forTemp_nameErr">
                Please enter a document name with at least 3 characters.
              </p>
            ) : (
              ""
            )}
            {/* START: Save button removed — title now auto-saves on blur (onBlur above) */}
            {/* {templateTitle != "" && (
              <FormHeaderInputSaveBtn
                onClick={saveFormHeader}
                style={{
                  marginLeft: "32px",
                  padding: "3px 26px",
                  background: "#57bf7f",
                  borderRadius: "4px",
                  border: "0px",
                }}
              >
                Save
              </FormHeaderInputSaveBtn>
            )} */}
            {/* END: Save button */}

            {/* START: Close button removed — no longer needed since auto-save is on blur */}
            {/* <FormHeaderInputCloseBtn
              onClick={() => {
                formEdit();
              }}
              style={{
                height: "28.5px",
                border: "1px solid #dbdbdb",
                color: "#718096",
                borderRadius: "4px",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                paddingLeft: "10px",
                marginLeft: "32px",
                paddingRight: "10px",
              }}
            >
              <FormHeaderInputCloseBtnIcon />
            </FormHeaderInputCloseBtn> */}
            {/* END: Close button */}
          </>
        )}
      </Div>
      <Div
        height="48px"
        color="#FFFFFF"
        dis="flex"
        justifyContent="space-between"
        alignItems="center"
        padding="0px 10px"
      >
        {fromTemplate == "Dashboard" && (
          <Div dis="flex">
            {patientdetails.img_url !== null ? (
              <>
                <Image
                  src={generateFileURL(
                    fileTypes.profileimages,
                    patientdetails.img_url,
                  )}
                  className="img-pat-bts_note"
                />
              </>
            ) : (
              <div className="patname_first img-pat-bts_note bts-pat-text">
                {patientdetails.fname.charAt(0).toUpperCase()}
              </div>
            )}
            <>
              <Div marginleft="10px">
                <Div color="#2E2E2E">
                  {patientdetails.fname}
                  {patientdetails.lname}
                </Div>
              </Div>
            </>
          </Div>
        )}

        {eid !== "" && (
          <Div dis="flex">
            {patientdetails.img_url !== null ? (
              <>
                <Image
                  src={generateFileURL(
                    fileTypes.profileimages,
                    patientdetails.img_url,
                  )}
                  className="img-pat-bts_note"
                />
              </>
            ) : (
              <div className="patname_first img-pat-bts_note bts-pat-text">
                {patientdetails.uname.charAt(0).toUpperCase()}
              </div>
            )}
            <>
              <Div marginleft="10px">
                {/* <Div color="#2E2E2E">{patientdetails.uname}</Div> */}
                <Div title={patientdetails.uname} color="#2E2E2E">
                  {patientdetails.uname.length > 30
                    ? `${patientdetails.uname.slice(0, 30)}...`
                    : patientdetails.uname}
                </Div>

                <Div size="12px" color="#2E2E2E">
                  {moment(patientdetails.pc_eventDate).format("MMMM DD, YYYY")}{" "}
                  ,{" "}
                  {moment(patientdetails.pc_startTime, "HH:mm").format(
                    "h:mm a",
                  )}{" "}
                  - {moment(appt_endTime, "HH:mm").format("h:mm a")}
                </Div>
              </Div>
            </>
          </Div>
        )}
        {/* NEW: Wrapped right-side items in a single flex group for proper alignment */}
        <Div
          dis="flex"
          alignItems="center"
          marginleft="auto"
          style={{ gap: "8px" }}
        >
          {
            patientdetails.sign_lock === 1 ||
              patientdetails.supervisorsign_lock === 1 || (
                // (Mode !== "Viewer" && (
                <Div className="clinical_notes_search">
                  <Select
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    showSearch
                    allowClear
                    suffixIcon={<CustomSuffixIcon />}
                    className={
                      SpecialityErr
                        ? "ant_select_dropdown_alt style_for_category_appt ant-sel-err-border"
                        : "ant_select_dropdown_alt style_for_category_appt"
                    }
                    value={specialty}
                    onChange={(value, option) => {
                      handlesetSpecial(option || { value: "" });
                    }}
                    placeholder="Select Speciality"
                    filterOption={(input, option) =>
                      option?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    <Option value="" title="Select Speciality">
                      Select Speciality
                    </Option>
                    {specialtyList.map((item, ind) => (
                      <Option value={item} key={item + ind} title={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                </Div>
              )
            // ))
          }
          {!isDisabled && (
            <Select
              virtual={false}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              suffixIcon={<CustomSuffixIcon />}
              className="ant_select_dropdown_alt "
              defaultValue="Encounter"
              value={Category}
              onSelect={(value) => {
                setCategoryValue(value);
              }}
              placeholder="Select Category"
              disabled={isDisabled}
            >
              <Option
                value="Encounter"
                disabled={fromTemplate == "Dashboard" ? true : false}
              >
                Encounter
              </Option>
              <Option value="Intake" disabled={isDisabled}>
                Intake
              </Option>
              <Option value="Assessment" disabled={isDisabled}>
                Assessment
              </Option>
              <Option value="Other" disabled={isDisabled}>
                Other
              </Option>
            </Select>
          )}
          {/* END NEW wrapper */}

          {/* START: Editor dropdown commented out as per requirement (hidden from New Document Template popup) */}
          {/* <Select
            virtual={false}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            suffixIcon={<CustomSuffixIcon />}
            className="ant_select_dropdown_alt texteditore_button_color style_for_edit_viewer"
            placeholder="Editor"
            // disabled={true}
            disabled={
              patientdetails.sign_lock === 1 ||
              patientdetails.supervisorsign_lock === 1 ||
              (fromTemplate !== "Dashboard" && eid === "")
                ? true
                : false
            }
            onChange={(value) => changeMode(value)}
          >
            <Option value="Editor">Editor</Option>
            {(fromTemplate === "Dashboard" || eid !== "") && (
              <Option value="Viewer">Viewer</Option>
            )}
          </Select> */}
          {/* END: Editor dropdown */}

          {patientdetails.sign_lock === 1 ||
          patientdetails.supervisorsign_lock === 1 ||
          Mode === "Viewer" ? (
            <></>
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                setOpenNewTemplate(true);
              }}
              disabled={!storedNames.m_templete}
            >
              Choose from Library
            </Button>
          )}

          {(fromTemplate === "Dashboard" ||
            fromTemplate === "Notes" ||
            eid !== "") && (
            <>
              <Div cursor="pointer" onClick={(e) => OpenCard()}>
                <AiOutlineMore className="more_action_addd_note" />
              </Div>
              <DropdownContent
                marginLeft="-160px"
                width="179px"
                left="96%"
                top="10%"
                marginRight="16px"
                display={openCard ? "block" : "none"}
              >
                <DropdownList
                  color="#2E2E2E"
                  id="list2"
                  onClick={() => {
                    filedownload();
                  }}
                  padding="0px 0px 3px 20px"
                >
                  Download
                </DropdownList>
                {patientdetails?.sign_lock !== 1 &&
                  patientdetails?.supervisorsign_lock !== 1 && (
                    <DropdownList
                      onClick={() => DeleteNote()}
                      color="#E23D28"
                      id="list2"
                      padding="0px 0px 3px 20px"
                    >
                      Delete
                    </DropdownList>
                  )}
              </DropdownContent>
            </>
          )}
        </Div>
      </Div>
      {FormDataErr ? (
        <p className="errormessage Rev_count m-l-10">
          Please Fill Form Details
        </p>
      ) : (
        ""
      )}
      <Div
        overflow={
          patientdetails.sign_lock === 1 ||
          patientdetails.supervisorsign_lock === 1
            ? "auto"
            : "none"
        }
        className="template_list_jodit_editor"
      >
        <Div height="450px" borderBottom=" 1px solid rgba(46, 46, 46, 0.25)">
          {autoSaveStatus && (
            <div
              style={{
                position: "absolute",
                top: "10px",
                right: "40px",
                zIndex: 1000,
                backgroundColor:
                  autoSaveStatus === "Saving..."
                    ? "#fff3cd"
                    : autoSaveStatus === "Saved"
                      ? "#d4edda"
                      : "#f8d7da",
                color:
                  autoSaveStatus === "Saving..."
                    ? "#856404"
                    : autoSaveStatus === "Saved"
                      ? "#155724"
                      : "#721c24",
                padding: "4px 12px",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
                border: "1px solid currentColor",
              }}
            >
              {autoSaveStatus}
            </div>
          )}
          {patientdetails.sign_lock === 1 ||
          patientdetails.supervisorsign_lock === 1 ? (
            <Div padding="20px" borderTop="1px solid rgba(46, 46, 46, 0.25)">
              <p
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            </Div>
          ) : (
            <>
              {Mode === "Editor" ? (
                <EditDocument
                  ExtraContent={ExtraContent}
                  clearExtraContent={clearExtraContent}
                  data={Mode === "Editor" ? ChangedContent : content}
                  fromWhere={
                    fromTemplate === "Notes"
                      ? "Notes"
                      : eid !== ""
                        ? "Appointment"
                        : ""
                  }
                  ref={fref}
                  Mode={Mode}
                  setContentToParent={setContentToParent}
                />
              ) : (
                <Div
                  height="450px"
                  overflow="auto"
                  padding="20px"
                  borderTop="1px solid rgba(46, 46, 46, 0.25)"
                  style={{
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                  }}
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: updateImageInDocument(
                        viewdocumentdata1,
                        imagename,
                        "fromdangorus",
                      ),
                    }}
                  />
                </Div>
              )}
            </>
          )}
        </Div>
      </Div>
      <Div
        border={
          patientdetails.sign_lock === 1
            ? "1px solid #cbd5e0 !important"
            : "none"
        }
        alignItems="end"
        dis="flex"
        justifyContent="space-between"
        padding={
          patientdetails.sign_lock === 1
            ? "10px 10px 20px 20px"
            : "5px 10px 20px 20px"
        }
      >
        <>
          {patientdetails.sign_lock === 1 ? (
            <Div dis="flex">
              {eid !== "" && (
                <Div dis="flex">
                  <Div color="#138808" fontSize="14px" marginRight="10px">
                    Signed by {providername}
                  </Div>
                  <Button
                    className="save_active  for_sign_lock_btn"
                    variant="primary"
                    name={isSupervisor ? "UnLockSupervisor" : "UnLock"}
                    onClick={savedocument}
                    disabled={
                      disBtn ||
                      storedNames.notes_lock1_viewOnly ||
                      patientdetails.supervisorsign_lock === 1
                    }
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    Unlock
                  </Button>
                </Div>
              )}

              {patientdetails.supervisorsign_lock === 1 ? (
                <Div dis="flex">
                  <div
                    style={{
                      borderLeft: "2px solid #000000", // color of the vertical line
                      height: "24px", // adjust to match content height
                      marginRight: "10px",
                    }}
                  ></div>
                  <Div color="#138808" fontSize="14px" marginRight="10px">
                    Signed by {name}
                  </Div>
                  <Button
                    className="save_active for_sign_lock_btn"
                    variant="primary"
                    name="UnLockSupervisor"
                    onClick={savedocument}
                    disabled={disBtn || storedNames.notes_lock1_viewOnly}
                    style={{ marginRight: "10px" }}
                  >
                    Unlock
                  </Button>
                </Div>
              ) : (
                cosign && (
                  <Button
                    disabled={disable}
                    className="save_active"
                    variant="primary"
                    name="UnLock"
                    onClick={() => handleSign(true)}
                  >
                    Supervisor Sign
                  </Button>
                )
              )}
            </Div>
          ) : (
            <>
              {Mode === "Viewer" ? (
                <></>
              ) : (
                <>
                  {eid !== "" &&
                    content !== "" &&
                    patientdetails.note_add_edit !== 0 && (
                      <Div
                        style={{
                          position: "absolute",
                          left: "19px",
                          bottom: "15px",
                          display: "flex",
                        }}
                      >
                        <Button
                          className="save_active add_edit_con_form_cancel_btn"
                          variant="primary"
                          onClick={() => handleSign(false)}
                          disabled={
                            disBtn ||
                            !storedNames.notes_lock ||
                            patientdetails.supervisorsign_lock === 1
                          }
                          style={{
                            marginRight: "10px",
                          }}
                        >
                          Sign
                        </Button>

                        {patientdetails.supervisorsign_lock === 1 ? (
                          <Div dis="flex">
                            <div
                              style={{
                                borderLeft: "2px solid #000000", // color of the vertical line
                                height: "24px", // adjust to match content height
                                marginRight: "10px",
                              }}
                            ></div>
                            <Div
                              color="#138808"
                              fontSize="14px"
                              marginRight="10px"
                            >
                              Signed by {name}
                            </Div>
                            <Button
                              className="save_active for_sign_lock_btn"
                              variant="primary"
                              name="UnLockSupervisor"
                              onClick={savedocument}
                              disabled={
                                disBtn || storedNames.notes_lock1_viewOnly
                              }
                              style={{ marginRight: "10px" }}
                            >
                              Unlock
                            </Button>
                          </Div>
                        ) : (
                          cosign && (
                            <Button
                              disabled={disable}
                              className="save_active"
                              variant="primary"
                              name="UnLock"
                              onClick={() => handleSign(true)}
                            >
                              Supervisor Sign
                            </Button>
                          )
                        )}
                      </Div>
                    )}
                </>
              )}

              {/* {Mode === "Viewer" ? (
                <></>
              ) : ( */}
              <Div marginleft="auto">
                <Popup
                  offset={[-445, 280]}
                  content={
                    <GetStartedPopup
                      title="Add New Template"
                      bullets={[
                        "In the editor popup, set the Speciality and Category that the template is gonna be saved under.",
                        "Type your template content in the editor canvas and Click Save to save your template.",
                      ]}
                      currentStep={6}
                      totalSteps={8}
                      onNext={forexploretemplatemenu7}
                      width="320px"
                      onBack={forexploretemplatemenu5}
                      onClose={() => {
                        settemplateshowup6(false);
                        closeTemplate();
                      }}
                    />
                  }
                  open={templateshowup6}
                  disabled={!templateshowup6}
                  className="popup-arrow m-t-10"
                  onClose={() => {}}
                  closeOnDocumentClick={false}
                  closeOnEscape={false}
                  trigger={
                    <Button
                      className="close_active add_edit_con_form_cancel_btn m-r-20"
                      variant="light"
                      onClick={() => {
                        closeTemplate();
                        setTemplateName("");
                        setTemplateTitle("");
                      }}
                    >
                      Cancel
                    </Button>
                  }
                  position="left center"
                />

                <Button
                  className="save_active add_edit_con_form_cancel_btn"
                  variant="primary"
                  onClick={savedocument}
                  disabled={
                    disBtn || storedNames.manageAdministrationSettings_viewOnly
                  }
                >
                  Save
                </Button>
              </Div>
              {/* )} */}
            </>
          )}
        </>
      </Div>

      <Modal
        className="tl-library-modal popup_centre"
        centered
        show={openNewTemplate}
        onHide={() => {
          setOpenNewTemplate(false);
          setSelectedTemplate(null);
        }}
      >
        <Modal.Body className="tl-library-container" style={{ padding: 0 }}>
          <div className="tl-header">
            <h2 className="tl-title">Template Library</h2>
            <button
              className="tl-close-btn"
              onClick={() => {
                setOpenNewTemplate(false);
                setSelectedTemplate(null);
              }}
            >
              <IoCloseSharp />
            </button>
          </div>

          <div className="tl-content-scroll">
            <div className="tl-filters">
              <div className="tl-search-wrapper">
                <AiOutlineSearch className="tl-search-icon" size={20} />
                <input
                  type="text"
                  className="tl-search-input"
                  placeholder="Search Template"
                  value={searchVal}
                  onChange={(e) => setSearchVal(e.target.value)}
                />
              </div>

              <Select
                className="tl-specialty-select ant_select_dropdown_alt"
                placeholder="Select Specialty"
                value={specialty === "Select Specialty" ? undefined : specialty}
                onChange={(value, option) => {
                  handlesetSpecial(option || { value: "" });
                }}
                allowClear
                suffixIcon={<CustomSuffixIcon />}
              >
                {specialtyList.map((item, ind) => (
                  <Option value={item} key={item + ind} title={item}>
                    {item}
                  </Option>
                ))}
              </Select>

              <div className="tl-category-filters">
                <span className="tl-category-label">Category:</span>
                {["All", "Encounter", "Intake", "Assessment", "Other"].map(
                  (cat) => (
                    <button
                      key={cat}
                      type="button"
                      className={`tl-cat-chip ${selectedCategory === cat ? "active" : ""}`}
                      onClick={() => setSelectedCategory(cat)}
                    >
                      {cat}
                    </button>
                  ),
                )}
              </div>
            </div>

            <div className="tl-section-header">
              <h3 className="tl-section-title">Templates</h3>
              <p className="tl-section-desc">
                Find a template from the library to insert into your current
                note or use it to begin a new note.
              </p>
            </div>
            <div className="tl-grid">
              {loading ? (
                <div className="tl-no-results">
                  <div className="tl-spinner"></div>
                  <p style={{ marginTop: "10px" }}>Loading templates...</p>
                </div>
              ) : searchedData.length > 0 ? (
                <>
                  {searchedData
                    .filter((item) => {
                      // 1. Specialty Filter
                      if (specialty && specialty !== "Select Specialty") {
                        const itemSpec = (item.speciality || "").toLowerCase();
                        if (itemSpec !== (specialty || "").toLowerCase())
                          return false;
                      }

                      // 2. Category Filter
                      if (selectedCategory === "All") return true;

                      const itemCat = (
                        item.document_type ||
                        item.category ||
                        ""
                      ).toLowerCase();
                      const selected = (selectedCategory || "").toLowerCase();

                      // Intelligent mapping
                      if (selected === "encounter") {
                        return [
                          "encounter",
                          "appointment",
                          "soap",
                          "soap note",
                        ].includes(itemCat);
                      }
                      if (selected === "intake") {
                        return ["intake", "consent"].includes(itemCat);
                      }
                      if (selected === "assessment") {
                        return [
                          "assessment",
                          "questionnaire",
                          "measurement",
                        ].includes(itemCat);
                      }

                      return itemCat === selected;
                    })
                    .map((item, idx) => {
                      const itemCat = (
                        item.document_type ||
                        item.category ||
                        "Other"
                      ).toLowerCase();
                      return (
                        <div
                          key={item.id || idx}
                          className={`tl-card ${selectedTemplate?.id === item.id ? "selected" : ""}`}
                          onClick={() => setSelectedTemplate(item)}
                        >
                          <div className="tl-card-badges">
                            <span className={`tl-badge tl-badge-${itemCat}`}>
                              {itemCat}
                            </span>
                            {item.speciality && (
                              <span className="tl-badge tl-badge-specialty">
                                {item.speciality}
                              </span>
                            )}
                          </div>
                          <h4 className="tl-card-name">{item.form_name}</h4>
                          <div className="tl-card-footer">
                            <div className="tl-card-date">
                              {item.date
                                ? moment(item.date).format("MMM DD, YYYY")
                                : "No date"}
                            </div>
                            <button
                              className="tl-use-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSearchVal(item.form_name);
                                setTemplateAppId(item.id);
                                setDataForUseTemplate(item.file_url);
                                setUseTemplate(
                                  item.form_name,
                                  item.id,
                                  item.file_url,
                                );
                                setSelectedTemplate(null);
                              }}
                            >
                              Use Template
                            </button>
                          </div>
                        </div>
                      );
                    })}

                  {searchedData.filter((item) => {
                    // 1. Specialty Filter
                    if (specialty && specialty !== "Select Specialty") {
                      const itemSpec = (item.speciality || "").toLowerCase();
                      if (itemSpec !== (specialty || "").toLowerCase())
                        return false;
                    }

                    // 2. Category Filter
                    if (selectedCategory === "All") return true;
                    const itemCat = (
                      item.document_type ||
                      item.category ||
                      ""
                    ).toLowerCase();
                    const selected = (selectedCategory || "").toLowerCase();

                    if (selected === "encounter") {
                      return [
                        "encounter",
                        "appointment",
                        "soap",
                        "soap note",
                      ].includes(itemCat);
                    }
                    if (selected === "intake") {
                      return ["intake", "consent"].includes(itemCat);
                    }
                    if (selected === "assessment") {
                      return [
                        "assessment",
                        "questionnaire",
                        "measurement",
                      ].includes(itemCat);
                    }

                    return itemCat === selected;
                  }).length === 0 && (
                    <div
                      className="tl-no-results"
                      style={{ gridColumn: "1 / -1" }}
                    >
                      No templates found for the selected category.
                    </div>
                  )}
                </>
              ) : (
                <div className="tl-no-results">
                  No templates found matching your criteria.
                </div>
              )}
            </div>
          </div>

          <div className="tl-footer">
            <Button
              className="close_active"
              variant="light"
              style={{ minWidth: "120px" }}
              onClick={() => {
                setOpenNewTemplate(false);
                setSelectedTemplate(null);
                setSearchVal("");
              }}
            >
              Cancel
            </Button>
            <Button
              className="save_active"
              variant="primary"
              style={{ minWidth: "120px" }}
              disabled={!selectedTemplate}
              onClick={() => {
                if (selectedTemplate) {
                  setSearchVal(selectedTemplate.form_name);
                  setTemplateAppId(selectedTemplate.id);
                  setDataForUseTemplate(selectedTemplate.file_url);
                  setUseTemplate(
                    selectedTemplate.form_name,
                    selectedTemplate.id,
                    selectedTemplate.file_url,
                  );
                  setSelectedTemplate(null);
                }
              }}
            >
              Proceed
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {isCreate && (
        <Modal
          className="client-popup patient-pop popup_centre"
          centered
          id="add-patientflag"
          show={isCreate}
          onHide={HanldeCloseSignature}
        >
          <Modal.Header closeButton className="mk-all-pdng-20 border-0">
            <div className="cat-md-title-txt">Add Signature</div>
          </Modal.Header>
          <Modal.Body className="mk-all-pdng-20-2">
            <Form.Group
              controlId="signatureName"
              style={{ marginBottom: "15px" }}
            >
              <Form.Label>Your Name</Form.Label>
              {isSupervisor ? (
                <>
                  <Select
                    virtual={false}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Enter your name"
                    suffixIcon={<CustomSuffixIcon />}
                    className="w-100"
                    value={name}
                    onChange={(value, option) => {
                      setName(value); // this is user.title
                      setsaveshow(true);
                      setSelectedProviderId(option.key); // this is user.id
                    }}
                  >
                    {UserSearchDatas.map((user) => (
                      <Option
                        key={user.id}
                        value={user.title}
                        title={user.title}
                      >
                        {user.title}
                      </Option>
                    ))}
                  </Select>
                </>
              ) : (
                <Form.Control
                  disabled={!isSupervisor}
                  type="text"
                  placeholder="Enter your name"
                  value={providername}
                  onChange={(e) => setName(e.target.value)}
                />
              )}
            </Form.Group>
            <Form.Group
              controlId="signaturePreview"
              style={{ marginBottom: "20px" }}
            >
              <Form.Label>Preview</Form.Label>
              <div
                style={{
                  minHeight: "100px",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  padding: "10px",
                  backgroundColor: "rgba(64, 123, 255, 0)",
                  fontFamily: "'Shadows Into Light', cursive",
                  fontSize: "1.8em",
                }}
              >
                {isSupervisor ? name : providername}
              </div>
            </Form.Group>

            <div className="d-flex justify-content-end">
              {saveshow && (
                <Button
                  variant="primary"
                  onClick={() =>
                    handleprimaryproviderchange(selectedProviderId)
                  }
                  style={{ marginRight: "125px" }}
                >
                  Save
                </Button>
              )}
              <Button
                variant="outline-primary"
                onClick={HanldeCloseSignature}
                style={{ marginRight: "8px" }}
              >
                Cancel
              </Button>
              {isSupervisor ? (
                <Button
                  className="save_active  for_sign_lock_btn"
                  variant="primary"
                  name={isSupervisor ? "SignLockSupervisor" : "SignLock"}
                  onClick={savedocument}
                  disabled={!storedNames.notes_lock}
                >
                  Sign & Lock
                </Button>
              ) : (
                <Button
                  className="save_active  for_sign_lock_btn"
                  variant="primary"
                  name={isSupervisor ? "SignLockSupervisor" : "SignLock"}
                  onClick={savedocument}
                  disabled={!storedNames.notes_lock}
                >
                  Sign & Lock
                </Button>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
      <Modal
        className="alert-popup-message"
        show={ModalAlerShow1}
        onHide={() => setModalAlerShow1(false)}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {successmsg}
        </div>
      </Modal>
    </>
  );
};

export default TemplateWorkAreas;
